import { SERVICE_NAMES } from '@hsl-ems/contracts';

export interface ApiHealth {
  status: 'ok' | 'unavailable';
  service: string;
  timestamp: string;
  dependencies?: Record<string, 'up' | 'down'>;
}

function isApiHealth(value: unknown): value is ApiHealth {
  if (typeof value !== 'object' || value === null) return false;
  const candidate = value as Record<string, unknown>;
  return (
    (candidate.status === 'ok' || candidate.status === 'unavailable') &&
    candidate.service === SERVICE_NAMES.API &&
    typeof candidate.timestamp === 'string'
  );
}

export async function fetchApiHealth(fetcher: typeof fetch = fetch): Promise<ApiHealth> {
  const baseUrl = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3000';
  const response = await fetcher(`${baseUrl}/health/ready`, {
    headers: { Accept: 'application/json' },
  });
  const payload: unknown = await response.json();

  if (!response.ok || !isApiHealth(payload)) {
    throw new Error('API readiness check failed');
  }

  return payload;
}
